module.exports = __webpack_public_path__ + "static/media/VEROSTRAS_MENU-normal.8b566ffe.png";